import errorsRoutes from '@/modules/errors/errors.routes';

// import superRoutes from './super.routes';
import inspectionRoutes from './inspection.routes';
// import thirdRoutes from './third.routes';

export default [...errorsRoutes, ...inspectionRoutes];
